import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const marginListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'rateSourceId',
    label: 'Rate source',
  },
  {
    name: 'currencyFromId',
    label: 'From',
  },
  {
    name: 'currencyToId',
    label: 'To',
  },
  {
    name: 'isCustom',
    label: 'Fees settings',
  },
  {
    name: 'tariffId',
    label: 'Tariff',
  },
  {
    name: 'tariff',
    label: 'Tariff client type',
  },
  {
    name: 'riskScoreRangeId',
    label: 'Tariff Risk',
  },
];

export const marginListColumnsLabels = {
  rateSourceId: 'Rate source',
  currencyToId: 'Currency to',
  tariffId: 'Tariff',
};

export const marginListSchema = {
  rateSourceId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyToId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  tariffId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const marginListFiltersSchema = [
  {
    name: 'rateSourceId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter rate source...',
  },
  {
    name: 'currencyToId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by rate source...',
  },
  {
    name: 'tariffId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by tariff...',
  },
];
